import { ApiService, ApiServiceGetResponse } from '@services'
import { StarDustBalance, TapBalanceBackend } from '@store'

export const getGetTapsBalanceApi = async (
  signal?: AbortSignal
): Promise<ApiServiceGetResponse<TapBalanceBackend>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/bank/taps`,
    signal,
  })

  return { ok, data: data || null }
}

export const getGetStardustBalanceApi = async (): Promise<
  ApiServiceGetResponse<StarDustBalance>
> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/bank/stardust`,
  })

  return { ok, data: data || null }
}

export const getGetStarsBalanceApi = async (
  signal?: AbortSignal
): Promise<ApiServiceGetResponse<number>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/bank/stars`,
    signal,
  })

  return { ok, data }
}
